module.exports = __webpack_public_path__ + "img/news-back.cc295ff5.png";